import { matchPath } from "react-router-dom";

const defaultTitle = "EE PASS: Educator Effectiveness Preparation and Support System";

const routeTitles = [
    { path: "/", title: "EE PASS: Educator Effectiveness Preparation and Support System - Welcome" }, // default
    { path: "/auth", title: "EE PASS: Authentication" },
    { path: "/login", title: "EE PASS: Log In" },
    { path: "/logout", title: "EE PASS: Log Out" },
    { path: "/learning-modules", title: "EE PASS: Learning Modules" },
    { path: "/resources", title: "EE PASS: Resources" },
    { path: "/video-library", title: "EE PASS: Video Library" },
    { path: "/share", title: "EE PASS: Content Share" },

    { path: "/my-dashboard", title: "EE PASS: My Dashboard" },
    { path: "/profile", title: "EE PASS: User Profile" },
    { path: "/analytics", title: "EE PASS: My Analytics" },

    { path: "/Observation/Teacher", title: "EE PASS: Teacher Observations" },
    { path: "/Observation/Teacher/:observationId", title: (params) => `EE PASS: Teacher Observation > ${params.observationId}` }, 
    { path: "/Observation/Teacher/SelfReflection/:observationId", title: (params) => `EE PASS: Teacher Observation > Self-Reflection >  ${params.observationId}` }, 
    { path: "/Observation/Teacher/review/:observationId", title: (params) => `EE PASS: Teacher Observation > Review >  ${params.observationId}` }, 

    { path: "/Observation/SchoolAdmin", title: "EE PASS: School Admin Observations" }, 
    { path: "/Observation/SchoolAdmin/:observationId", title: (params) => `EE PASS: Administrator Observation >  ${params.observationId}` }, 
    { path: "/Observation/SchoolAdmin/SelfReflection/:observationId", title: (params) => `EE PASS: Administrator Observation > Self-Reflection >  ${params.observationId}` }, 
    { path: "/Observation/SchoolAdmin/review/:observationId", title: (params) => `EE PASS: Administrator Observation > Review >  ${params.observationId}` }, 

    { path: "/Observation/print/:observationId", title: (params) => `EE PASS: Observation > Print >  ${params.observationId}` }, 
    { path: "/Observation/printdetailed/:observationId", title: (params) => `EE PASS: Observation > Print Detailed >  ${params.observationId}` }, 
  
    { path: "/survey", title: "EE PASS: Surveys" },
    { path: "/survey/generalsurvey", title: (params) => "EE PASS: General Surveys" },
    { path: "/survey/generalsurvey/:surveyId", title: (params) => `EE PASS: General Survey > ${params.surveyId}` },
    { path: "/survey/teachersurvey", title: (params) => "EE PASS: Teacher Surveys" },
    { path: "/survey/teachersurvey/:surveyId", title: (params) => `EE PASS: Teacher Survey > ${params.surveyId}` },
    { path: "/survey/teachersurvey/review/:surveyId", title: (params) => `EE PASS: Teacher Survey > Review > ${params.surveyId}` },
    { path: "/survey/principalsurvey", title: (params) => "EE PASS: Administrator Surveys" },
    { path: "/survey/principalsurvey/:surveyId", title: (params) => `EE PASS: Administrator Survey > ${params.surveyId}` },
    { path: "/survey/principalsurvey/review/:surveyId", title: (params) => `EE PASS: Administrator Survey > Review > ${params.surveyId}` },

    { path: "/certifications", title: `EE PASS: Certifications` },
    { path: "/certifications/teacher", title: `EE PASS: Teacher Evaluator Certifications` },
    { path: "/certifications/teacher/:id", title: (params) => `EE PASS: Teacher Evaluator Certification > ${params.id}` },
    { path: "/certifications/administrator", title: `EE PASS: Administrator Evaluator Certifications` },
    { path: "/certifications/administrator/:id", title: (params) => `EE PASS: Administrator Evaluator Certification > ${params.id}` },

    { path: "/reports", title: `EE PASS: Reports` },
    { path: "/reports/teacher", title: `EE PASS: Teacher Reports` },
    { path: "/reports/school-administrator", title: `EE PASS: School Admin Reports` },
    { path: "/reports/niet", title: `EE PASS: NIET Reports` },
    { path: "/report/:url", title: `EE PASS: Reports` },
    
    { path: "/content", title: `EE PASS: Content Library` },

    { path: "/EchoAI", title: `EE PASS: Enhanced Search` },
    { path: "/admin/EchoAI", title: "EE PASS: Enhanced Search Administration" },
    
    { path: "/admin/:id", title: (params) => `EE PASS: ${params.id} Management` },
];

export function setPageTitleFromRoute(location) {
  // Set the document title based on the current route
  let foundRoute = null;
  for (const r of routeTitles) {
    // If path contains a wildcard/splat, don't require exact end match
    const useEnd = !r.path.includes('*');
    const match = matchPath({ path: r.path, end: useEnd }, location.pathname);
    if (match) {
      foundRoute = r;
      if (typeof r.title === "function") {
        return r.title(match.params);
      } else {
        return r.title;
      }
    }
  }
  if (!foundRoute) {
    return defaultTitle;
  }
}